import { Dispatch } from 'redux';
import { ActionTypes, ReduxAction } from './types';
import { Auftragsvorlage, AuftragsvorlageService } from '../../api';
import { setNotification } from '../../utils/notificationUtils';
import { INFO } from '../../layouts/notification/Notification';

export const resetAuftragsvorlageerfassung =
  () => (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.RESET_AUFTRAGSVORLAGEERFASSUNG,
    });
  };

export const setAuftragsvorlageerfassungField =
  (value: any, fieldName: string) => (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_AUFTRAGSVORLAGEERFASSUNG_FIELD,
      payload: { value: value, fieldName: fieldName },
    });
  };

export const createAuftragsvorlage =
  (auftragsvorlage: Auftragsvorlage, closeHandler: () => void) =>
  async (dispatch: Dispatch<ReduxAction>): Promise<void> => {
    new AuftragsvorlageService()
      .createAuftragsvorlage(auftragsvorlage)
      .then(response => {
        dispatch({
          type: ActionTypes.SAVE_AUFTRAGSVORLAGE,
          payload: response.data,
        });
        closeHandler();
        dispatch({
          type: ActionTypes.RESET_AUFTRAGSVORLAGEERFASSUNG,
        });
        setNotification(
          'Die Auftragsvorlage ' +
            response.data.vorlageName +
            ' wurde erfolgreich gespeichert.',
          [],
          INFO,
          10000
        );
      });
  };

export const updateAuftragsvorlage =
  (id: number, auftragsvorlage: Auftragsvorlage, closeHandler: () => void) =>
  async (dispatch: Dispatch<ReduxAction>): Promise<void> => {
    new AuftragsvorlageService()
      .updateAuftragsvorlage(id, auftragsvorlage)
      .then(response => {
        dispatch({
          type: ActionTypes.SAVE_AUFTRAGSVORLAGE,
          payload: response.data,
        });
        closeHandler();
        dispatch({
          type: ActionTypes.RESET_AUFTRAGSVORLAGEERFASSUNG,
        });
        setNotification(
          'Die Auftragsvorlage ' +
            response.data.vorlageName +
            ' wurde erfolgreich gespeichert.',
          [],
          INFO,
          10000
        );
      });
  };

export const checkVorlageExists =
  (name: string, mandantId?: number) =>
  async (
    dispatch: (arg: { type: ActionTypes; payload: Auftragsvorlage[] }) => void
  ) => {
    new AuftragsvorlageService().exists(name, mandantId).then(response => {
      dispatch({
        type: ActionTypes.VORLAGE_NAME_EXISTS,
        payload: response.data,
      });
    });
  };
